import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ensures we always land at the top of the page when navigating between routes.
 * React Router does not do this automatically for SPA navigation.
 */
export function ScrollToTop() {
  const location = useLocation();

  // Prevent browser from restoring scroll positions on SPA nav
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    // If there's a hash, try to scroll to that element.
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }

    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname, location.search, location.hash]);

  return null;
}
